import { FormDataConsumer, SelectInput } from "react-admin";
import CustomDateTimeInput from "shared/components/inputs/CustomDateTimeInput";
import { optimizerCertificationStatusChoices } from "shared/enums/reactAdminChoices";
import DynamicEndDateInputs from "./DynamicEndDateInputs";
import { TransformGroupCertificationData } from "./types";
import { Stack } from "@mui/material";

const GroupCertificationEditInputs = () => {
  return (
    <>
      <SelectInput source="status" choices={optimizerCertificationStatusChoices} fullWidth />
      <CustomDateTimeInput source="start_date" fullWidth />

      <Stack direction="row" spacing={2} width="100%" alignItems="center" justifyContent="space-between">
        <FormDataConsumer<TransformGroupCertificationData>>
          {({ formData }) => {
            return <DynamicEndDateInputs formData={formData} />;
          }}
        </FormDataConsumer>
      </Stack>
    </>
  );
};

export default GroupCertificationEditInputs;
